export default "__VITE_ASSET__ZncpK9y2__"